module.exports = __webpack_public_path__ + "static/media/bg-parede.0203efe1.webp";